import { render } from "./DonationView.vue?vue&type=template&id=46ccda70&scoped=true"
import script from "./DonationView.vue?vue&type=script&lang=js"
export * from "./DonationView.vue?vue&type=script&lang=js"

import "./DonationView.vue?vue&type=style&index=0&id=46ccda70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ccda70"]])

export default __exports__